import {createSelector} from '@reduxjs/toolkit'

import {eq} from '@shared/helpers/lang'

import {FDSPhase, FDSPhaseType} from '@web/core/constants'

import {FDSStatus} from '../constants'

import {RootState} from './../interfaces'

export const fdsSelector = (state: RootState) => state.fds

const isProcessRestoring = eq(FDSPhase.RESTORING)
const isProcessInitializing = eq(FDSPhase.INITIALIZING)
const isProcessIdle = eq(FDSPhase.IDLE)
const isProcessStarted = (currentPhase: FDSPhaseType) =>
    [FDSPhase.STARTED, FDSPhase.PROCESSING, FDSPhase.FINISH].some((phase) => phase === currentPhase)
const isProcessFinished = eq(FDSPhase.FINISH)
const isProcessing = eq(FDSStatus.PENDING)
const hasFinishedSuccessfully = eq(FDSStatus.FULFILLED)
export const currentFdsStatusSelector = createSelector(fdsSelector, ({phase, status}) => {
    // inactive => restoring/initializing => idle
    const isRestoring = isProcessRestoring(phase)
    const isInitializing = isProcessInitializing(phase)
    const isIdle = isProcessIdle(phase)
    const isStarted = isProcessStarted(phase)
    const inProgress = isStarted && isProcessing(status)
    const success = hasFinishedSuccessfully(status)

    return {
        isRestoring,
        isInitializing,
        isIdle,
        isStarted,
        inProgress,
        done: isProcessFinished(phase) && !inProgress,
        success,
    }
})
